<template>
    <div id="login-change">
        <div class="dropdown" v-if="isLoggedIn">
            <a href="#" class="dropdown-toggle" id="accountMenuList" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-boundary="window">
                <img class="d-none d-lg-inline-block" :src="pluginPathTheme + '/images/user-login.svg'" alt="user">
                <img class="d-lg-none" :src="pluginPathTheme + '/images/user-login-white.svg'" alt="user">
                <span class="d-none d-sm-inline">{{ $translate("Ceres::Template.loginHello", {"username": username }) }}</span>
            </a>
            <div class="account-menu dropdown-menu dropdown-menu-right small m-0 p-0 mw-100">
                <div class="list-group" aria-labelledby="accountMenuList" >
                    <a :href="$ceres.urls.myAccount" class="list-group-item small">
                        <img class="d-none d-lg-inline-block" :src="pluginPathTheme + '/images/user-login.svg'" alt="user">
                        <img class="d-lg-none" :src="pluginPathTheme + '/images/user-register-white.svg'" alt="user">
                        {{ $translate("Ceres::Template.loginMyAccount") }}
                    </a>
                    <a href="#" class="list-group-item small" v-logout><i class="fa fa-sign-out"></i> {{ $translate("Ceres::Template.loginLogout") }}</a>
                </div>
            </div>
        </div>
        <div v-if="!isLoggedIn">
            <a class="" v-if="showLogin" :href="isLogin ? 'javascript:void(0)' : '#login'" :data-toggle="isLogin ? false : 'modal'" @click="createLoginModal(); unmarkInputFields();">
                <img class="d-none d-lg-inline-block" :src="pluginPathTheme + '/images/user-login.svg'" alt="user">
                <img class="d-lg-none" :src="pluginPathTheme + '/images/user-login-white.svg'" alt="user">
                <span class="d-none d-sm-inline">{{ $translate("Ceres::Template.login") }}</span>
            </a>
            <template v-if="showRegistration">
                <span class="pipe" v-if="!showLogin"></span>
                <a class="" :href="$ceres.urls.registration" >
                    <img class="d-none d-lg-inline-block" :src="pluginPathTheme + '/images/user-regsiter.svg'" alt="user">
                    <img class="d-lg-none" :src="pluginPathTheme + '/images/user-register-white.svg'" alt="user">
                    <span class="d-none d-sm-inline">{{ $translate("Ceres::Template.loginRegister") }}</span>
                </a>
            </template>
        </div>
    </div>
</template>

<script>
import ValidationService from "ceres/app/services/ValidationService";
import { mapGetters, mapActions } from "vuex";

export default {
    props: {
        showRegistration: {
            type: Boolean,
            default: true
        },
        showLogin: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        pluginPathTheme()
        {
          return App.pluginPathTheme
        },
        ...mapGetters([
           "username",
           "isLoggedIn"
        ])
    },

    data()
    {
        return {
            isLogin: App.templateType === "login",
            isRegister: App.templateType === "register"
        };
    },

    methods: {
        unmarkInputFields()
        {
            ValidationService.unmarkAllFields($("#login"));
            ValidationService.unmarkAllFields($("#registration"));
        },

        createLoginModal()
        {
            this.loadComponent("login-modal");

        },

        createRegisterModal()
        {
            this.loadComponent("register-modal");
        },

        ...mapActions([
            "loadComponent"
        ])
    }
}
</script>
